<nohs-form-wrapper style="height: calc(100% - 1rem); margin-top: 1rem;" [presentation]="presentation$ | async" (navClick)="navClick($event)"></nohs-form-wrapper>
@if (displayNonblockingSpinner) {
  <div class="floating loader">
    <div class="spinner dark"></div>
  </div>
}
@if (displayBlockingSpinner) {
  <div class="blocking loader">
    <div class="spinner"></div>
  </div>
}